import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {Provider} from '@angular/core';
import {ApiRequestInterceptorService} from './api-request-interceptor.service';
import {ApiResponseInterceptorService} from './api-response-interceptor.service';

/**
 * The HTTP interceptor chain, in order (#34).
 *
 * Angular hands an outgoing request to interceptors in the order they are provided, so the
 * request interceptor must come first: it attaches the Authorization header, and the response
 * interceptor uses the presence of that header to tell a stale-session 401 apart from an
 * anonymous or login-attempt 401. Registered the other way round, the response interceptor
 * sees the request before the header exists and the stale-session rule silently never fires.
 *
 * Kept in its own file so the order can be asserted by a unit test without pulling the whole
 * application module into the spec.
 */
export const HTTP_INTERCEPTOR_PROVIDERS: Provider[] = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ApiRequestInterceptorService,
    multi: true
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ApiResponseInterceptorService,
    multi: true
  },
];
